export const UPDATE_CONFIG_GERAL = 'UPDATE_CONFIG_GERAL'
export const UPDATE_CONFIG_GERAL_PENDING = 'UPDATE_CONFIG_GERAL_PENDING'
export const UPDATE_CONFIG_GERAL_SUCCESS = 'UPDATE_CONFIG_GERAL_SUCCESS'
export const UPDATE_CONFIG_GERAL_FAILURE = 'UPDATE_CONFIG_GERAL_FAILURE'

export const FIND_CONFIG_GERAL = 'FIND_CONFIG_GERAL'
export const FIND_CONFIG_GERAL_PENDING = 'FIND_CONFIG_GERAL_PENDING'
export const FIND_CONFIG_GERAL_SUCCESS = 'FIND_CONFIG_GERAL_SUCCESS'
export const FIND_CONFIG_GERAL_FAILURE = 'FIND_CONFIG_GERAL_FAILURE'